// extracted by mini-css-extract-plugin
module.exports = {"component":"Blank_component__1I1q8","images":"Blank_images__2OQ1f","contents":"Blank_contents__MbkQ1","description":"Blank_description__xNpla","actions":"Blank_actions__33tVc"};